<template>
	<div class="correction-wrap pt-6 pt-sm-8">
		<h1 class="report--title mb-2">
			{{ $t('report.card.log.title') }}
		</h1>
		<h2 class="report--text mb-6 white-space-pre">
			{{ $t('report.card.log.sub-title') }}
		</h2>
		<v-img
			src="@/assets/images/mockup-pt1.png"
			class="mx-auto pt-10 pb-5 px-1"
			:width="userDevice === 'mobile' ? 225 : 266"
			:height="userDevice === 'mobile' ? 274 : 310"
			position="botton center"
		>
			<div
				class="px-3 pb-14 scroll-div"
				:style="`width: ${userDevice === 'mobile' ? 225 : 266}px;height: ${
					userDevice === 'mobile' ? 274 : 310
				}px; `"
				style="overflow-y: auto"
			>
				<v-img
					width="80%"
					:src="require(`@/assets/images/express-card-${language}.jpg`)"
					class="mb-3"
					alt=""
				/>
				<div
					v-for="log in logs"
					:key="log.id"
					class="d-flex"
					:class="{
						'justify-start': log.type === 'Tutor',
						'justify-end': log.type === 'Tutee',
					}"
				>
					<div
						class="chat-bubble mb-3"
						:class="log.type.toLowerCase()"
						v-html="log.content"
					></div>
				</div>
			</div>
		</v-img>
	</div>
</template>

<script>
export default {
	data() {
		return {
			logs: [
				{ id: 1, type: 'Tutor', content: 'Let me know when you’re ready!' },
				{ id: 2, type: 'Tutee', content: 'Yes, I’m ready!' },
				{
					id: 3,
					type: 'Tutor',
					content: 'Let’s practice the expressions that you learned above.',
				},
				{
					id: 4,
					type: 'Tutor',
					content: this.$t('log-card.tutor-1'),
				},
				{
					id: 5,
					type: 'Tutor',
					content: this.$t('log-card.tutor-2'),
				},
				{
					id: 6,
					type: 'Tutee',
					content: 'The phone breaks up. I can hardly hear you.',
				},
				{
					id: 7,
					type: 'Tutor',
					content: 'Almost! So close!',
				},
				{
					id: 8,
					type: 'Tutor',
					content:
						'>>> <span class="edit--text font-weight-bold">*You are</span> breaking up. I can hardly hear you.',
				},
				{
					id: 9,
					type: 'Tutor',
					content:
						'When you use the phrase <span class="font-weight-bold">‘to break up,’</span> you need to set the subject to <span class="font-weight-bold">‘you’</span>.',
				},
			],
		}
	},
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.correction-wrap {
	margin: 0 auto;
	width: 396px;
	height: 470px;
	border-radius: 20px;
	background-color: #f1f5ff;
}

@media screen and (max-width: 600px) {
	.correction-wrap {
		width: 100%;
		height: 425px;
	}
}

.report--title {
	font-size: 22px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: center;
	color: #1a1a1a;
}
.report--text {
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.8px;
	text-align: center;
	color: #1a1a1a;
}

.chat-bubble {
	border-radius: 15px;
	padding: 10px 20px 10px 15px;
	max-width: 90%;
	font-size: 12px;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	letter-spacing: -0.21px;
	color: #1a1a1a;
	word-wrap: break-word;
}
.chat-bubble.tutor {
	background-color: #f5f5f5;
	font-weight: normal;
}
.chat-bubble.tutee {
	background-color: #1e78ff;
	font-weight: bold;
	color: #fff;
}
.edit--text {
	color: #00a882;
}

.scroll-div::-webkit-scrollbar {
	width: 3px;
}
.scroll-div::-webkit-scrollbar-track {
	background-color: transparent;
}
.scroll-div::-webkit-scrollbar-thumb {
	border-radius: 5px;
	background-color: grey;
}
</style>
